'use strict';

// autofact-lib-ts-chatbot imports { jwtDecode } from 'jwt-decode' (v4 API).
// Yarn resolutions may pin jwt-decode@3; npm may resolve v4. This shim
// normalizes both to the same named export for the browser bundle.
var decode = require('jwt-decode');
var jwtDecode;

if (typeof decode === 'function') {
  // jwt-decode v3 CJS: module.exports is the decode function
  jwtDecode = decode;
} else if (decode && typeof decode.jwtDecode === 'function') {
  // jwt-decode v4 CJS/ESM interop: { jwtDecode, InvalidTokenError }
  jwtDecode = decode.jwtDecode;
} else if (decode && typeof decode.default === 'function') {
  // ESM default interop
  jwtDecode = decode.default;
} else {
  throw new Error('jwt-decode-shim: unable to resolve jwtDecode export');
}

var exportsObj = {
  jwtDecode: jwtDecode,
  default: jwtDecode,
};

if (decode && decode.InvalidTokenError) {
  exportsObj.InvalidTokenError = decode.InvalidTokenError;
}

module.exports = exportsObj;
